/* eslint-disable eqeqeq, no-unused-vars */
import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import NoDataText from "../../_components/NoDataText/NoDataText";
import ConfirmationAlert from "../../_components/ConfirmationAlert/ConfirmationAlert";
import accessoriesManagementService from "../../_services/accessoriesManagement.service";
import authenticationService from "../../_services/authentication.service";
import accessoryfinderService from "../../_services/accessoryfinder.service";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../AccessoriesManagement/AccessoriesManagement.css";
import UpdateModeAccessoriesManagement from "../../_components/UpdateModeAccessoriesManagement";

class AccessoriesManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isModelOpen: false,
      result: {},
      resultForSearch: {},
      errors: {},
      searchText: "",
      brandData: [],
      id: 0,
      isImagePreview: true,
      showUpdateModel: false,
      updateModel: {},
      editorState: EditorState.createEmpty(),
      imagePreviewUrl: "",
      model: {
        accessory_modelNo: "",
        accessoryName: "",
        image: null,
        description: "",
        accessoryModelMapping: [
          {
            id: 0,
            brandName: "",
            accessoryId: "",
            vacuumModelId: "",
            vacuumModel: [],
            vacuumSeriesId: "",
            vacuumSeries: [],
            enabled: true,
            createdBy: authenticationService?.currentUserValue?.id,
            error: {},
          },
        ],
        enabled: true,
        createdBy: authenticationService?.currentUserValue?.id,
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.ddlRowChnage = this.ddlRowChnage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
  }
  handleSubmit = (e) => {
    if (this.validateForm()) {
      let { model } = this.state;
      let formData = new FormData();
      formData.append("Accessory_modelNo", model.accessory_modelNo);
      formData.append("AccessoryName", model.accessoryName);
      formData.append("Image", model.image);
      formData.append("Description", model.description);
      formData.append("Enabled", model.enabled);
      formData.append("CreatedBy", model.createdBy);
      formData.append(
        "accessoryModelMappingJsonString",
        JSON.stringify(model.accessoryModelMapping)
      );

      accessoriesManagementService
        .addAccessorynModel(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  };
  responseShow(obj) {
    if (obj.isSuccess) {
      this.resetForm();
      this.getData();
    }

    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: obj.message,
      buttons: [
        {
          label: "Close",
          onClick: this.handleNo,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember });
  }
  handleNo = (e) => {
    this.setState({ isModelOpen: false, alertMember: {} });
  };
  handleResetForm = (e) => {
    this.resetForm();
  };
  resetForm() {
    this.setState({
      errors: {},
      isImagePreview: true,
      editorState: EditorState.createEmpty(),
      imagePreviewUrl: "",
      model: {
        accessory_modelNo: "",
        accessoryName: "",
        image: null,
        description: "",
        accessoryModelMapping: [
          {
            id: 0,
            brandName: "",
            accessoryId: "",
            vacuumModelId: "",
            vacuumModel: [],
            vacuumSeriesId: "",
            vacuumSeries: [],
            enabled: true,
            createdBy: authenticationService?.currentUserValue?.id,
            error: {},
          },
        ],
        enabled: true,
        createdBy: authenticationService?.currentUserValue?.id,
      },
    });

    this.fileInput.value = "";
  }

  validateForm() {
    let { model } = this.state;
    let rows = [...this.state?.model?.accessoryModelMapping];

    let errors = {};
    let isFormValid = true;

    if (!model.accessory_modelNo) {
      isFormValid = false;
      errors["accessory_modelNo"] = "Enter Accessory ModelNo";
    }
    if (!model.accessoryName) {
      isFormValid = false;
      errors["accessoryName"] = "Enter Accessory Name";
    }
    if (!model.image) {
      isFormValid = false;
      errors["image"] = "Select Image";
    }

    let desc = model.description.replace(/<[^>]*>/g, "").trim();

    if (desc === null || desc === "") {
      isFormValid = false;
      errors["description"] = "Enter Description";
    }

    rows.map((item, idx) => {
      if (!item.brandName) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          brandName: "Select Brand Name",
        };
        isFormValid = false;
      }
      if (!item.vacuumModelId) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          vacuumModelId: "Select Vacuum Model",
        };
        isFormValid = false;
      }
      if (item.vacuumSeries.length > 0 && !item.vacuumSeriesId) {
        rows[idx]["error"] = {
          ...rows[idx]["error"],
          vacuumSeriesId: "Select vacuum SeriesId",
        };
        isFormValid = false;
      }

      return isFormValid;
    });
    this.setState({
      model: { ...this.state?.model, accessoryModelMapping: rows },
      errors: errors,
    });
    return isFormValid;
  }
  handleAddRow = () => {
    const item = {
      id: 0,
      brandName: "",
      accessoryId: "",
      vacuumModelId: "",
      vacuumModel: [],
      vacuumSeriesId: "",
      vacuumSeries: [],
      enabled: true,
      createdBy: authenticationService?.currentUserValue?.id,
      error: {},
    };
    let accessoryModelMapping = this.state?.model?.accessoryModelMapping;
    accessoryModelMapping.push(item);
    this.setState({
      model: {
        ...this.state?.model,
        accessoryModelMapping: accessoryModelMapping,
      },
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.state?.model.accessoryModelMapping];
    rows.splice(idx, 1);
    this.setState({
      model: { ...this.state?.model, accessoryModelMapping: rows },
    });
  };
  handleChange(event) {
    const { name, value } = event.target;
    const { model, errors } = this.state;

    this.setState({
      model: {
        ...model,
        [name]: value,
      },
      errors: {
        ...errors,
        [name]: "",
      },
    });
  }
  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
    let { model, errors } = this.state;
    model.description = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );

    this.setState({
      model: { ...model, model },
      errors: {
        ...errors,
        description: "",
      },
    });
  };

  handleClick = (e) => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleImagePreview = (e) => {
    this.setState({ isImagePreview: !this.state?.isImagePreview });
  };

  componentDidMount() {
    this.getData();
    this.getBrand();
  }
  getData() {
    accessoriesManagementService
      .getAccessorynModelList()
      .then((data) => this.setState({ result: data, resultForSearch: data }))
      .catch((error) => console.log("Error :" + error));
  }
  GetActionFormat = (cell, row, rowIndex) => {
    return (
      <div>
        <button
          data-tip="hello world"
          type="button"
          className="btn btn-outline-primary btn-sm ts-buttom"
          size="sm"
          onClick={() => this.handleModelEdit(cell, row, rowIndex)}
        >
          <i className="fa fa-edit"></i>
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm ml-2 ts-buttom"
          size="sm"
          onClick={() => this.handleModelDelete(cell, row, rowIndex)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  };

  enabledFormatter = (cell, row) => {
    return cell ? <span>Yes</span> : <span>No</span>;
  };
  handleImageChange(e) {
    e.preventDefault();
    let file = e.target.files[0];
    let fileName = file.name;
    let size = file.size;
    let fileExtn = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
    let reader = new FileReader();

    if (this.validateFile(fileExtn, size)) {
      let { model } = this.state;
      model.image = file;

      reader.onloadend = () => {
        this.setState({
          model: { ...model, model },
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);
    } else {
      e.target.value = null;
    }
  }
  validateFile(fileExtn, size) {
    debugger;
    let { errors } = this.state;
    let isValid = true;
    let message = "";
    const extnList = ["JPEG", "jpg", "PNG", "png"];
    const list = extnList.filter((u) => u === fileExtn);
    if (list && list.length == 0) {
      isValid = false;
      message = "Only JPEG, PNG files are allowed";
    } else if (size > 2000000) {
      message = "File size should not be more than 2MB";
      isValid = false;
    }
    this.setState({
      errors: {
        ...errors,
        image: message,
      },
    });

    return isValid;
  }
  ddlRowChnage = (idx) => (e) => {
    const { name, value } = e.target;
    let rows = [...this.state?.model?.accessoryModelMapping];
    rows[idx][name] = value;

    if (value != "") {
      rows[idx]["error"] = { ...rows[idx]["error"], [name]: "" };

      if (name === "brandName") {
        accessoryfinderService
          .getVacuumModelsByBrand(value)
          .then((data) => {
            if (data.isSuccess) {
              rows[idx]["vacuumModel"] = data.data;
              this.setState({
                model: { ...this.state?.model, accessoryModelMapping: rows },
              });
            }
          })
          .catch((error) => console.log("Error :" + error));
      } else if (name === "vacuumModelId") {
        accessoryfinderService
          .getModelSeries(value)
          .then((data) => {
            if (data.isSuccess) {
              rows[idx]["vacuumSeries"] = data.data;
              this.setState({
                model: { ...this.state?.model, accessoryModelMapping: rows },
              });
            }
          })
          .catch((error) => console.log("Error :" + error));
      } else {
        this.setState({
          model: { ...this.state?.model, accessoryModelMapping: rows },
        });
      }
    }
  };

  getBrand = () => {
    accessoryfinderService
      .getAllBrands()
      .then((data) => this.setState({ brandData: data.data }))
      .catch((error) => console.log("Error :" + error));
  };

  searchOnChange = (e) => {
    const { searchText, resultForSearch } = this.state;
    const { value } = e.target;

    if (resultForSearch.data && resultForSearch.data.length > 0) {
      const filteredData = resultForSearch.data.filter(
        (model) =>
          model.accessory_modelNo.toLowerCase().indexOf(value.toLowerCase()) >
            -1 ||
          model.accessoryName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      this.setState({
        result: { data: [...filteredData] },
        searchText: value,
      });
    }
  };
  handleModelDelete(cell, row, rowIndex) {
    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: this.handleYes,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
        {
          label: "No",
          onClick: this.handleNo,
          cssclass: "btn btn-danger btn-sm ml-2 ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember, id: cell });
  }

  handleYes = (e) => {
    e.preventDefault();
    const { id } = this.state;
    const model = {
      AccessoryId: id,
    };
    let formData = JSON.stringify(model);
    accessoriesManagementService
      .delete(formData)
      .then((data) => this.responseShow(data))
      .catch((error) => console.log("Error :" + error));
  };
  handleNo = (e) => {
    this.setState({ isModelOpen: false, alertMember: {} });
  };
  handleModelEdit(cell, row, rowIndex) {
    accessoriesManagementService
      .getAccessorynModelByAccessorylID(cell)
      .then((data) =>
        this.setState({ showUpdateModel: true, updateModel: data.data })
      )
      .catch((error) => console.log("Error :" + error));
  }
  updateClose = (isUpdated) => {
    if (isUpdated) {
      this.getData();
    }

    this.setState({ showUpdateModel: false, updateModel: {} });
  };
  render() {
    const options = {
      sizePerPage: 5,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };
    const columns = [
      {
        dataField: "accessory_modelNo",
        text: "Accessory Model No",
        headerStyle: (colum, colIndex) => {
          return { width: "210px", textAlign: "left" };
        },
      },
      {
        dataField: "accessoryName",
        text: "Accessory Name",
      },
      {
        dataField: "enabled",
        text: "Active",
        formatter: this.enabledFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "70px", textAlign: "center" };
        },
      },
      {
        text: "#Action",
        dataField: "accessoryId",
        formatter: this.GetActionFormat,
        headerStyle: (colum, colIndex) => {
          return { width: "100px", textAlign: "center" };
        },
      },
    ];
    const showClass = `page-wrapper chiller-theme ${
      this.state.isOpen ? "toggled" : ""
    }`;
    const {
      isImagePreview,
      isOpen,
      isModelOpen,
      alertMember,
      result,
      searchText,
      model,
      editorState,
      brandData,
      imagePreviewUrl,
      showUpdateModel,
    } = this.state;
    console.log(this.state);

    let imagePreview = null;
    if (imagePreviewUrl) {
      imagePreview = (
        <img className="imgPreview" alt="imgPreviewUrl" src={imagePreviewUrl} />
      );
    } else {
      imagePreview = "";
    }
    let btnText = "Hide Preview";
    if (isImagePreview) {
      btnText = "Show Preview";
    }

    return (
      <React.Fragment>
        {isModelOpen ? <ConfirmationAlert {...alertMember} /> : null}
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h4 className="text-left">Accessories Management</h4>
              <hr className="hr" />
              <div className="row">
                <div className="col-sm-12">
                  <div className="box box-primary">
                    <form name="form" onSubmit={this.handleSubmit}>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="accessory_modelNo">
                                Accessory Model No
                              </label>
                              <input
                                id="accessory_modelNo"
                                name="accessory_modelNo"
                                value={model.accessory_modelNo}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state.errors.accessory_modelNo
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Accessory Model No"
                              />
                              {this.state.errors.accessory_modelNo && (
                                <small className="help-block">
                                  {this.state.errors.accessory_modelNo}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="accessoryName">
                                Accessory Name{" "}
                              </label>
                              <input
                                id="accessoryName"
                                name="accessoryName"
                                value={model.accessoryName}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state.errors.accessoryName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Accessory Name"
                              />
                              {this.state.errors.accessoryName && (
                                <small className="help-block">
                                  {this.state.errors.accessoryName}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="description ">Description</label>
                              <div
                                style={{ minHeight: "300px" }}
                                className={
                                  this.state.errors.description
                                    ? " invalid"
                                    : "border"
                                }
                              >
                                <Editor
                                  editorState={editorState}
                                  editorStyle={{ lineHeight: "75%" }}
                                  wrapperClassName="demo-wrapper"
                                  editorClassName="demo-editor"
                                  toolbar={{
                                    inline: {
                                      visible: true,
                                      inDropdown: false,
                                      bold: { visible: true },
                                      italic: { visible: true },
                                      underline: { visible: true },
                                      strikeThrough: { visible: true },
                                      monospace: { visible: true },
                                    },
                                    blockType: { visible: true },
                                    fontSize: { visible: true },
                                    fontFamily: { visible: true },
                                    list: {
                                      visible: true,
                                      inDropdown: true,
                                      unordered: { visible: true },
                                      ordered: { visible: true },
                                      indent: { visible: true },
                                      outdent: { visible: true },
                                    },
                                    textAlign: {
                                      visible: true,
                                      inDropdown: true,
                                      left: { visible: true },
                                      center: { visible: true },
                                      right: { visible: true },
                                      justify: { visible: true },
                                    },
                                    colorPicker: { visible: true },
                                    textIndent: {
                                      inDropdown: false,
                                      className: undefined,
                                      component: undefined,
                                      dropdownClassName: undefined,
                                      options: ["indent", "outdent"],
                                      indent: { className: undefined },
                                      outdent: { className: undefined },
                                    },
                                    link: {
                                      visible: false,
                                      inDropdown: true,
                                      addLink: { visible: true },
                                      removeLink: { visible: true },
                                    },
                                    image: {
                                      visible: false,
                                      fileUpload: true,
                                      url: true,
                                    },
                                    history: {
                                      visible: true,
                                      inDropdown: true,
                                      undo: { visible: true },
                                      redo: { visible: true },
                                    },
                                  }}
                                  onEditorStateChange={this.onEditorStateChange}
                                />
                              </div>
                              {this.state.errors.description && (
                                <small className="help-block">
                                  {this.state.errors.description}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="AccessoryImage">
                                Accessory Image
                              </label>
                              <input
                                type="file"
                                onChange={(e) => this.handleImageChange(e)}
                                accept=".jpg,.jpeg,.png"
                                id="AccessoryImage"
                                ref={(ref) => (this.fileInput = ref)}
                                name="image"
                                className={
                                  "form-control" +
                                  (this.state.errors.image ? " invalid" : "")
                                }
                                placeholder="Accessory Image"
                              />
                              {this.state.errors.image && (
                                <small className="help-block">
                                  {this.state.errors.image}
                                </small>
                              )}
                              {!isImagePreview ? (
                                <div>{imagePreview}</div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              {model.image ? (
                                <button
                                  className="submitButton"
                                  type="button"
                                  onClick={(e) => this.handleImagePreview(e)}
                                >
                                  {btnText}
                                </button>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="tbl_vacuumModelSeries">
                                Model Details
                              </label>
                              <table
                                className="table table-bordered"
                                id="tbl_vacuumModelSeries"
                              >
                                <tbody>
                                  {model.accessoryModelMapping.map(
                                    (item, idx) => (
                                      <tr id="addr0" key={idx}>
                                        <td style={{ width: "8%" }}>
                                          {idx + 1}
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.brandName}
                                            onChange={this.ddlRowChnage(idx)}
                                            className={
                                              "form-control" +
                                              (item.error.brandName
                                                ? " invalid"
                                                : "")
                                            }
                                            name="brandName"
                                          >
                                            <option
                                              key="brandSelected"
                                              value=""
                                            >
                                              Select Brand
                                            </option>

                                            {brandData.length &&
                                              brandData.map((itemInner) => (
                                                <option
                                                  key={itemInner.value}
                                                  value={itemInner.value}
                                                >
                                                  {itemInner.text}
                                                </option>
                                              ))}
                                          </select>
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.vacuumModelId}
                                            onChange={this.ddlRowChnage(idx)}
                                            className={
                                              "form-control" +
                                              (item.error.vacuumModelId
                                                ? " invalid"
                                                : "")
                                            }
                                            name="vacuumModelId"
                                          >
                                            <option
                                              key="modelSeriesSelected"
                                              value=""
                                            >
                                              Select Vacuum Model
                                            </option>
                                            {item.vacuumModel.length &&
                                              item.vacuumModel.map(
                                                (itemInner) => (
                                                  <option
                                                    key={itemInner.value}
                                                    value={itemInner.value}
                                                  >
                                                    {itemInner.text}
                                                  </option>
                                                )
                                              )}
                                          </select>
                                        </td>
                                        <td style={{ width: "27%" }}>
                                          <select
                                            value={item.vacuumSeriesId}
                                            onChange={this.ddlRowChnage(idx)}
                                            className={
                                              "form-control" +
                                              (item.error.vacuumSeriesId
                                                ? " invalid"
                                                : "")
                                            }
                                            name="vacuumSeriesId"
                                          >
                                            <option
                                              key="modelSeriesSelected"
                                              value=""
                                            >
                                              Select Vacuum Model Series
                                            </option>
                                            {item.vacuumSeries.length &&
                                              item.vacuumSeries.map(
                                                (itemInner) => (
                                                  <option
                                                    key={itemInner.value}
                                                    value={itemInner.value}
                                                  >
                                                    {itemInner.text}
                                                  </option>
                                                )
                                              )}
                                            {/* ))} */}
                                          </select>
                                        </td>
                                        <td style={{ width: "11%" }}>
                                          {idx > 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-outline-danger btn-sm"
                                              onClick={this.handleRemoveSpecificRow(
                                                idx
                                              )}
                                            >
                                              Remove
                                            </button>
                                          ) : null}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                              <button
                                type="button"
                                onClick={this.handleAddRow}
                                className="btn btn-outline-primary btn-sm"
                              >
                                Add Row
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <hr />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <button
                              type="button"
                              onClick={this.handleSubmit}
                              className="btn btn-primary"
                            >
                              SAVE
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              onClick={this.handleResetForm}
                              className="btn btn-primary"
                            >
                              RESET
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <hr className="hr" />
              <div className="row">
                <div className="col-sm-6">
                  <h5>Accessories Management List</h5>
                </div>
                <div className="col-sm-6">
                  <input
                    name="searchBox"
                    value={searchText}
                    onChange={(e) => this.searchOnChange(e)}
                    maxLength="50"
                    type="text"
                    className="form-control"
                    placeholder="search"
                  />
                </div>
              </div>
              <div className="row margin-top">
                <div className="col-sm-12">
                  <div className="box">
                    {result.data && result.data.length > 0 ? (
                      <BootstrapTable
                        keyField={"accessoryId"}
                        data={result.data}
                        columns={columns}
                        pagination={paginationFactory(options)}
                      />
                    ) : (
                      <NoDataText columns={columns} message="No Data Found" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        {showUpdateModel ? (
          <UpdateModeAccessoriesManagement
            updateModel={this.state.updateModel}
            updateClose={this.updateClose}
            brandData={this.state.brandData}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default AccessoriesManagement;
